import React from 'react'
import sun from '../../assets/sun.png';
import moon from '../../assets/moon.png';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { switchTheme } from '../../redux/appSlice';

export const ThemeSwitcher = ({height}) => {
  const isLightTheme = useSelector((state) => state.app.isLightTheme);
  const dispatch = useDispatch();

  const toggleThemeHandler = () => {
    dispatch(switchTheme({}));
  }
  const defaultHeight = 64;
  const calcHeight = height || defaultHeight;
  
  return (
    <div className='theme-switcher'>
      <img className='pointer' style={{height: calcHeight + 'px'}} src={isLightTheme ? sun : moon} alt="Переключатель темы" onClick={toggleThemeHandler} />
      </div>
  );
}
